import React from 'react';
import Helmet from 'react-helmet';

const WorkHelmet = (props) => {
  const title = props.title;
  const description = 'Regis Biron is a digital designer based out of Boston with a focus on web, identity, and digital development.';

  return (
    <Helmet
      titleTemplate="%s — Regis Design"
      title={title}
      meta={[
        { name: 'description', content: description },
        { property: 'og:type', content: 'article' }
      ]}
    />
  );
};

export default WorkHelmet;



// WEBPACK FOOTER //
// ./src/views/Work/Helmet.js